/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import * as Ui from './styles';

const propTypes = {
  data: PropTypes.array,
  selectable: PropTypes.bool,
  onSelectItem: PropTypes.func,
  onRemoveItem: PropTypes.func,
};

const defaultProps = {
  data: [
    {
      value: 0,
      label: 'Title#0',
      data: [
        { value: 1, label: 'Data #1' },
        { value: 2, label: 'Data #2' },
      ],
    },
    {
      value: 1,
      label: 'Title#1',
      data: [
        { value: 3, label: 'Data #3' },
        { value: 4, label: 'Data #4' },
      ],
    },
    {
      value: 2,
      label: 'Title#2',
      data: [
        { value: 5, label: 'Data #5' },
        { value: 6, label: 'Data #6' },
      ],
    },
  ],
  selectable: false,
  onRemoveItem: null,
  onSelectItem: null,
};

export default function ListView(props) {
  const { data, selectable, onRemoveItem, onSelectItem } = props;

  // on remove card
  function handleRemove(cardItemId) {
    if (onRemoveItem) onRemoveItem(cardItemId);
  }

  // on select item in card
  function handleSelect(cardItemId, cardSubItemId) {
    if (onSelectItem) onSelectItem(cardItemId, cardSubItemId);
  }

  return (
    <Ui.Container>
      {data.map((item) => (
        <Ui.MiniCardWrapper
          key={item.value}
          id={item.value}
          title={item.label}
          isLoading={item.isDataLoading}
          data={item.data}
          selectable={selectable}
          onTrash={() => handleRemove(item.value)}
          onClick={(subItemId) => handleSelect(item.value, subItemId)}
        />
      ))}
    </Ui.Container>
  );
}

ListView.propTypes = propTypes;
ListView.defaultProps = defaultProps;
